var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errors.length > 0)?_c('div',{staticClass:"form-errors-v3"},_vm._l((_vm.errors),function(error){return _c('p',{key:error.uid},[_vm._v(" "+_vm._s(error.$message)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }